import { FC } from 'react';

export const AnalyticsTooltipSeparator: FC = () => {
  return (
    <div className="w-full border-t border-dashed border-zinc-300 my-1"></div>
  );
};
